import { streamFetch } from "~/lib/fetchClient";

const AI_SERVICE_BASE_URL = process.env.SHAKAPACKER_PUBLIC_AI_SERVICE_URL;
const COUNT_TOKENS_TIMEOUT_MS = 2000;

/**
 * Call the AI service /count_tokens endpoint to get an estimated
 * token count for system prompt + conversation history.
 *
 * Returns { inputTokens, provider, model, encoding, isApproximate } on success,
 * or null on timeout/error (caller should fall back to character approximation).
 */
const countTokensFromService = async (
  systemPrompt,
  messages,
  { tier, product, editorType, outputFormat } = {},
) => {
  if (!AI_SERVICE_BASE_URL) {
    return null;
  }

  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), COUNT_TOKENS_TIMEOUT_MS);

  try {
    const response = await streamFetch(`${AI_SERVICE_BASE_URL}/count_tokens`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        systemPrompt: systemPrompt || undefined,
        messages: messages.map(({ role, content }) => ({ role, content })),
        tier,
        product: product || undefined,
        editorType: editorType || undefined,
        outputFormat: outputFormat || undefined,
      }),
      signal: controller.signal,
    });

    return await response.json();
  } catch {
    return null;
  } finally {
    clearTimeout(timeout);
  }
};

/**
 * Fallback: approximate token count using character length / 4.
 * ~85-90% accurate for English text, used when /count_tokens is unavailable.
 */
export const approximateTokenCount = (text) => {
  if (!text) {
    return 0;
  }
  return Math.ceil(text.length / 4);
};

export default countTokensFromService;
